export default class KingsfordFooter {
    // ctor assign vars & init
    constructor() {
        this.initListeners();
    }

    initListeners() {
        $('.js-footer-toggle').on('click', (e) => {
            console.info('toggle');
            $(e.currentTarget).closest('.kingsford-footer__nav-list-group').toggleClass('active');
        });
    }
}
